import { forwardRef, type ComponentProps } from "react";

import { Input } from "../ui/input";

export interface NumberInputProps extends Omit<ComponentProps<typeof Input>, "type" | "value" | "onChange"> {
  value: number | null | undefined;
  onChange: (value: number | null) => void;
}

/** Pole liczbowe emituje `null` po wyczyszczeniu, ponieważ `Number("")` zwraca `0`,
 *  a react-hook-form traktuje `undefined` jak powrót do wartości domyślnej. Normalizacja
 *  do kontraktu DTO pozostaje odpowiedzialnością schematu na granicy aplikacji. */
const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>(({ value, onChange, ...rest }, ref) => (
  <Input
    {...rest}
    ref={ref}
    type="number"
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
  />
));
NumberInput.displayName = "NumberInput";

export { NumberInput };
